const translateBatchUrl = '/apph5/customer-api/translate/batch'
export function getCurrentLocaleTransferCode(locale) {
  const localeCode = String(locale || 'zh-CN').trim()
  const codeMap = {
    'en': 'en',
    'en-US': 'en',
    'vi': 'vi',
    'vi_VN': 'vi',
    'vi-VN': 'vi',
    'ja': 'ja',
    'jp': 'ja',
    'ja_JP': 'ja',
    'ja-JP': 'ja',
    'zh-TW': 'zh-tw',
    'zh-Hant': 'zh-tw',
    'tw': 'zh-tw',
  }

  if (codeMap[localeCode])
    return codeMap[localeCode]

  if (localeCode.toLowerCase().startsWith('zh'))
    return ''

  return localeCode
}

function parseTranslateBatchTexts(res) {
  const transferRes = res?.data?.result
  const transferResults = res?.data?.results || res?.data?.data?.results || []
  const transferData = res?.data?.data
  const transferListData = res?.data?.list
  const transferResultData = res?.data?.resultList

  if (Array.isArray(transferResults) && transferResults.length) {
    return transferResults
      .slice()
      .sort((a, b) => Number(a?.index || 0) - Number(b?.index || 0))
      .map(item => item?.translatedText || '')
  }

  if (Array.isArray(transferData))
    return transferData

  if (Array.isArray(transferListData))
    return transferListData

  if (Array.isArray(transferResultData))
    return transferResultData

  if (typeof transferRes === 'string')
    return transferRes.split('\n')

  return []
}

function resolveTranslateFetcher(fetcher) {
  if (typeof fetcher === 'function')
    return fetcher

  if (typeof globalThis.$fetch === 'function')
    return globalThis.$fetch

  if (typeof globalThis.fetch === 'function') {
    return async (url, options = {}) => {
      const response = await globalThis.fetch(url, {
        ...options,
        body: options?.body ? JSON.stringify(options.body) : undefined,
      })
      return response.json()
    }
  }

  return null
}

export async function translateMallBatchTexts(options = {}) {
  const rawTexts = Array.isArray(options.texts) ? options.texts : []
  const texts = Array.from(
    new Set(
      rawTexts
        .map(item => String(item || '').trim())
        .filter(Boolean),
    ),
  )

  const targetLanguage = getCurrentLocaleTransferCode(options.targetLanguage)
  const translatedMap = {}

  if (!texts.length || !targetLanguage) {
    return {
      texts,
      targetLanguage,
      translatedTexts: [],
      translatedMap,
    }
  }

  const fetcher = resolveTranslateFetcher(options.fetcher)

  if (typeof fetcher !== 'function') {
    texts.forEach((text) => {
      translatedMap[text] = text
    })
    return {
      texts,
      targetLanguage,
      translatedTexts: texts.slice(),
      translatedMap,
    }
  }

  for (let i = 0; i < texts.length; i += 100) {
    const chunk = texts.slice(i, i + 100)
    try {
      
      const res = await fetcher(translateBatchUrl + '?hiddenErrTip=1&uncheck401=1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          isSystemText: typeof options.isSystemText === 'number' ? options.isSystemText : 0,
          texts: chunk,
          sourceLanguage: options.sourceLanguage || 'zh',
          targetLanguage,
          appType: options.appType || 'react-mall-app',
        },
      })

      const translatedTexts = parseTranslateBatchTexts(res)
      chunk.forEach((text, index) => {
        translatedMap[text] = translatedTexts[index] || text
      })
    }
    catch {
      chunk.forEach((text) => {
        translatedMap[text] = text
      })
    }
  }

  return {
    texts,
    targetLanguage,
    translatedTexts: texts.map(text => translatedMap[text] || text),
    translatedMap,
  }
}
